/* img src path */

// board img path
export function iconPath(file: string) {
    return new URL(`../assets/img/pc/sub/${file}`, import.meta.url).href
}


//admin menu icon path
export function adminmenuiconPath(file: string) {
    return new URL(`../assets/img/pc/admin/${file}`, import.meta.url).href
}